import { Alert } from 'react-bootstrap';

const ForbiddenAlert = () => {
	return (
		<Alert variant="danger" style={{ margin: '10px' }}>
			<Alert.Heading>Forbidden</Alert.Heading>

			<p>You don't have permission to access the course.</p>
		</Alert>
	);
};

export default ForbiddenAlert;
